import { Injectable } from '@angular/core';
import { IEmpleadoData } from '@core/interfaces/entidades/empleado.entidad';
import { ICrearEmpleadoReq } from '@core/interfaces/request-response/empleado.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class EmpleadoApiService extends BaseHttpService {
  cargar() {
    return this.withLoader(
      this.httpClient.get<IEmpleadoData[]>(
        `${environment.apiUrl}${environment.apiPreFix}/usuario/ver-lista-empleado`,
      ),
    );
  }
  bloquear(id: number) {
    return this.withLoader(
      this.httpClient.delete(
        `${environment.apiUrl}${environment.apiPreFix}/usuario/eliminar-empleado/${id}`,
      ),
    );
  }
  desbloquear(id: number) {
    return this.withLoader(
      this.httpClient.post(
        `${environment.apiUrl}${environment.apiPreFix}/usuario/desbloquear-empleado/${id}`,
        {},
      ),
    );
  }
  editar(id: number, empleado: Partial<IEmpleadoData>) {
    return this.withLoader(
      this.httpClient.put<IEmpleadoData>(
        `${environment.apiUrl}${environment.apiPreFix}/usuario/editar-empleado/${id}`,
        empleado,
      ),
    );
  }
  crear(empleado: ICrearEmpleadoReq) {
    return this.withLoader(
      this.httpClient.post<IEmpleadoData>(
        `${environment.apiUrl}${environment.apiPreFix}/usuario/crear-empleado`,
        empleado,
      ),
    );
  }
}
